module.exports = __webpack_public_path__ + "static/logo-aefdcbbfae428750915edc890a4bc02b.svg";